export class DataStream {
  streamCode: string;
  descr?: string;
  labels?: string[] = [];
  values?: number[] = [];
  values2?: number[] = [];
  bgColors?: string[] = [];
  txtValues?: string[] = [];
  unitDescr?: string[] = [];
  hidden?: boolean = false;
  type?: string;
  color?: string;
  fillColor?: string;
  bgColor?: string;
  visible?: boolean = true;
  dashed?: boolean = false;
  yAxisID?: string;
  fill?: boolean = false;
}

export class LabKpiModel {
  allIncomingCases: KpiIncomingCases;
  digitalIncomingCases: KpiIncomingCases;
  cumulIncome: KpiCumulIncome;
  caseDelays: KpiCaseDelays;
  plantOrderStatus: KpiPlantOrderStatus;
  onlineUsers: KpiDonut;
  deliveryReq: KpiDonut;
  invoices: KpiDonut;
  greenClients: KpiCircle;
  yellowClients: KpiCircle;
  redClients: KpiCircle;
  activeClients: KpiCircle;
  abandonClients: KpiCircle;
  acuisitionFailClients: KpiCircle;
  profitTrends: KpiProfitTrends;
  cycleDuration: KpiCycleDuration;
  scanAnalog: KpiScanAnalog;
  itemRadar: KpiItemRadar;
  tryInTrends: KpiTryInTrends;
  fixTrends: KpiFixTrends;
  returnTrends: KpiReturnTrends;
  employeePerformance: KpiCartesian[];
  slScore: string;
  slColor: string;
  slMetrics: StoplightMetric[] = [];
}

export class KpiCircle {
  cnt: number;
  circleColor: string;
  deltaPct: number;
  deltaColor: string;
  label: string;
  arrowType: string;
  deltaCnt: number;
}

export class KpiDonut {
  categoryCode: string[];
  categoryDescr: string[];
  colorCode: string[];
  valCnt: number[];
  valPct: number[];
}

export class KpiPlantOrderStatus {
  plantId: string[];
  plantName: string[];
  totCnt: number[];
  regularCnt: number[];
  criticalCnt: number[];
  overdueCnt: number[];
  regularPct: number[];
  criticalPct: number[];
  overduePct: number[];
}

export class KpiCaseDelays {
  plantCnt: number;
  plantCircleColor: string;
  labCnt: number;
  labCircleColor: string;
}

export class KpiIncomingCases {
  cnt: number;
  label: string;
  arrowType: string;
  circleColor: string;
  deltaPct: number;
}

export class KpiCumulIncome {
  current: KpiStream;
  past: KpiStream;
  past2: KpiStream;
  breakeven: KpiStream;
}

export class KpiProfitTrends {
  income: KpiStream;
  incomePrev: KpiStream;
  orderPlacement: KpiStream;
  profit: KpiStream;
  profitPrev: KpiStream;
}

export class KpiScanAnalog {
  scans: KpiStream;
  analog: KpiStream;
}

export class KpiCycleDuration {
  current: KpiDonut;
  completed: KpiDonut;
}

export class KpiItemRadar {
  m1: KpiStream;
  m2: KpiStream;
  m3: KpiStream;
}

export class KpiTryInTrends {
  tryIn: KpiStream;
  tryInPrev: KpiStream;
  tryInClinic: KpiStream;
  tryInClinicPrev: KpiStream;
}

export class KpiFixTrends {
  fix: KpiStream;
  fixPrev: KpiStream;
  fixClinic: KpiStream;
  fixClinicPrev: KpiStream;
}

export class KpiReturnTrends {
  return: KpiStream;
  returnPrev: KpiStream;
  returnClinic: KpiStream;
  returnClinicPrev: KpiStream;
}

export class KpiStream {
  streamCode: string;
  dates: string[];
  monthName: string[];
  monthDescr: string;
  valCnt: number[];
  valSharePct: number[];
  unitDescr: string[];
  trendPct: number[];
  avgPrice: number[];
  arrowType: string[];
  itemGroup: string[];
  itemGroupDescr: string[];
}

export class ClinicStoplight {
  clinicId: number;
  clinicDescr: string;
  expanded?: boolean;
  metrics: StoplightMetric[] = [];
  snoozeSw: boolean;
  snoozeStartdate?: Date;
  snoozeNote?: string;
}

export class StoplightMetric {
  metricCode: string;
  descr: string;
  score: number;
  color: string;
  displayColor: string;
}


export class KpiConfig {
  filterType: string;
  featureCode: string;
  constructor(filterType: string, featureCode: string) {
    this.filterType = filterType;
    this.featureCode = featureCode;
  }
}

export class KpiCartesian {
  code: string;
  display: string;
  datapointCode: string[];
  datapointDescr: string[];
  valCnt: number[];
}